export default function debounce( func, wait = 0 ) {
	let timeout;

	return function( ...args ) {
		clearTimeout( timeout );

		timeout = setTimeout( () => {
			func.apply( this, args );
		}, wait );
	};
}

